import { FormLogicQuestionType } from './checkIfAnswerFulfillsRequirement'

export const getUsesUUIDs = (question: FormLogicQuestionType) =>
  ['SELECT', 'MULTI_SELECT', 'SEARCH_SELECT'].includes(question.questionType)

export default getUsesUUIDs
